module.exports = __webpack_public_path__ + "img/icon_heart.25538206.png";